import { Component } from '@angular/core';

@Component({
  selector: 'app-ntc24',
  templateUrl: './ntc24.component.html',
  styleUrl: '../../../../../../../../styles-tabelle-orari.css'
})
export class Ntc24Component {

}
